/**
 * # Links declarations
 *
 * We create links that can used to dynamically construct routes.
 * Result should match declarations in routes files.
 */
import { activeSwingIdAtom, activityIdAtom, globalStore } from '@store';

import * as PARAMETERS from './parameters';
import * as ROUTES from './routes';

export const getActivity = (activityId = globalStore.get(activityIdAtom)) =>
    `${ROUTES.ACTIVITIES}/${activityId}` as const;

export const getFullActivity = (
    activityId = globalStore.get(activityIdAtom),
    swingId = globalStore.get(activeSwingIdAtom),
) => `${ROUTES.ACTIVITIES}/${activityId}${swingId ? `/${PARAMETERS.SWING}/${swingId}` : ''}` as const;

export const getPlayback = () => `${getFullActivity()}/${PARAMETERS.PLAYBACK}` as const;

export const getPlaybackComparison = () =>
    `${getFullActivity()}/${PARAMETERS.PLAYBACK}/${PARAMETERS.PLAYBACK_COMPARISON}` as const;

export const getVisualizer3d = () => `${getFullActivity()}/${PARAMETERS.VISUALIZER_3D}` as const;

export const getLayoutEditor = (layoutId: number) => `${getFullActivity()}/${PARAMETERS.LAYOUT}/${layoutId}` as const;

export const getFloorSettings = () => `${getFullActivity()}/${PARAMETERS.FLOOR_SETTINGS}` as const;

export const getUserSettings = () => `${ROUTES.USER_SETTINGS}` as const;

export const getStudentSettings = () => `${getFullActivity()}${ROUTES.STUDENT_SETTINGS}` as const;

export const getClubs = () => `${getFullActivity()}/${PARAMETERS.CLUBS}` as const;

export const getTags = () => `${getFullActivity()}/${PARAMETERS.TAGS}` as const;

export const getParameters = () => `${getFullActivity()}/${PARAMETERS.PARAMETERS}` as const;

export const getActivities = (studentId?: string) =>
    `${ROUTES.ACTIVITIES}${studentId ? `?studentId=${studentId}` : ''}` as const;

export const getReport = () => `${getFullActivity()}/${PARAMETERS.REPORT}` as const;

export const getGoalReport = (layoutId: number) =>
    `${getFullActivity()}/${PARAMETERS.GOAL_REPORT}/${layoutId}` as const;

export const getLiveAnalysis = () => `${getActivity()}/${PARAMETERS.LIVE_ANALYSIS}` as const;
